"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayOfObjectsSearch = void 0;
const isEmpty_1 = require("./isEmpty");
const isNil_1 = require("./isNil");
// a fun and efficient alternative to .match()
const quickStringMatch = (input, searchForThis) => {
    if ((0, isNil_1.isNil)(input) || (0, isNil_1.isNil)(searchForThis))
        return false;
    const inputFormatted = input?.toString().toLowerCase();
    // will be a number>= 1 if a match, and 0 if no match, so we can just cast it to a boolean
    return !!(inputFormatted.length - inputFormatted.replace(searchForThis.toString().toLowerCase(), '').length);
};
// arrayOfObjectsSearch is a function called with something like this:
//
// arrayOfObjectsSearch(dataArray, 'scott 3033', ['id', 'first_name'])
//
// it returns the input array but filtered where at least one key for each
// array-element-object matches all the search terms.
const arrayOfObjectsSearch = (inputArray, searchTerms, objectKeysToSearchThrough) => {
    if (!searchTerms || (0, isEmpty_1.isEmpty)(searchTerms) || !inputArray || (0, isEmpty_1.isEmpty)(inputArray))
        return inputArray;
    // allow the programmer to give a string or an array for searchTerms
    const searchTermsArray = Array.isArray(searchTerms)
        ? searchTerms
        : searchTerms.split(' ').filter((term) => term !== '');
    const objectKeysToSearchThroughArray = Array.isArray(objectKeysToSearchThrough)
        ? objectKeysToSearchThrough
        : objectKeysToSearchThrough.toString().split(' ');
    // return the filtered array (which also has a reduce chained on)
    return inputArray.filter((row) => {
        // go through every search term given
        return (searchTermsArray
            .map((term) => {
            // go through every property listed
            return objectKeysToSearchThroughArray
                .map((col) => {
                if (row[col]) {
                    // do a check to see if the search term is included. Cast it to a number, since we'll add it up later
                    return +quickStringMatch(String(row[col]), term);
                }
                return 0;
            })
                .reduce((a, b) => a + b, 0);
        })
            // since we need ALL search terms to be matched on,
            // and since quickStringMatch returns a number > 0
            // when there is a match and a non-match is a 0, we
            // can multiply in our reduce so that way non-matches
            // will be excluded (since anything multiplied by zero
            // is also zero, which is a falsy value), since
            // filters, eliminate falsy values
            .reduce((a, b) => a * b, 1));
    });
};
exports.arrayOfObjectsSearch = arrayOfObjectsSearch;
//# sourceMappingURL=arrayOfObjectsSearch.js.map